const PageSizes = [10, 25, 50, 100];

export default PageSizes;
